import React, { useContext, useState } from 'react';
import { GetStatusId } from '../../../services/OnbordingService';
import { useNavigate } from 'react-router-dom';
import './UpdateStatus.css';
import { AppContext } from '../../../AppContext';

export default function EmailSearchComponent() {
    const [emailStatus, setEmailStatus] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { setCurrentStep } = useContext(AppContext);

    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleSearch = async () => {
        setError('');
        const trimmedEmail = emailStatus.trim();

        if (!validateEmail(trimmedEmail)) {
            setIsValidEmail(false);
            setError('Please enter a valid email');
            return;
        }
        setIsValidEmail(true);

        try {
            const response = await GetStatusId(trimmedEmail);
            if (response?.data?.status_id != null) {
                setCurrentStep(8);
                navigate('/updateStatus', {
                    state: {
                        emailStatuSend: trimmedEmail,
                        statusId: response.data.status_id,
                        business_name: response.data.business_name
                    }
                });
            } else {
                setError('Application does not exist.');
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.description) {
                setError(error.response.data.description);
            } else {
                setError('An unexpected error occurred.');
            }
        }
    };

    return (
        <div className="updated-container-email">
            <div style={{ position: 'relative' }}>
                <h3>Search Email to Get Status</h3>
                <input
                    type="text"
                    value={emailStatus}
                    onChange={(e) => setEmailStatus(e.target.value)}
                    placeholder="Enter email"
                    className={`email-input ${!isValidEmail ? 'invalid' : ''}`}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSearch();
                        }
                    }}
                />
                {error && <span className="error-message">{error}</span>}
            </div>
            <button className="button-status-email" onClick={handleSearch}>
                Search
            </button>
        </div>
    );
}
